import { List, ListItem, Stack, Typography } from "@mui/material";

import { GqlProtocolVisit } from "~/__generated__";
import { formatDate } from "~/modules/app/util/formatters";

import { ProtocolVisitCondition } from "../../types/ProtocolVisitCondition";

type Props = {
    condition: ProtocolVisitCondition;
    allVisits: GqlProtocolVisit[];
};

export default function ProtocolVisitConditionsSummary({ condition, allVisits }: Props) {
    switch (condition.type) {
        case "and":
        case "or":
            return (
                <Stack direction="column">
                    <Typography variant="body2" fontWeight="bold">
                        {condition.type === "and" ? "And" : "Or"}
                    </Typography>
                    <List component="ul" sx={{ p: 0, m: 0, paddingLeft: 2 }}>
                        {condition.conditions?.map(subCondition => (
                            <ListItem key={subCondition.id} sx={{ p: 0 }}>
                                <ProtocolVisitConditionsSummary allVisits={allVisits} condition={subCondition} />
                            </ListItem>
                        ))}
                    </List>
                </Stack>
            );
        case "beforeVisit":
            return (
                <Typography variant="caption">
                    <strong>{condition.minDaysBetween || 0}</strong> days before visit{" "}
                    <strong>{allVisits.find(visit => visit.id === condition.visitId)?.number}</strong>
                </Typography>
            );
        case "afterVisit":
            return (
                <Typography variant="caption">
                    <strong>{condition.minDaysBetween || 0}</strong> days after visit{" "}
                    <strong>{allVisits.find(visit => visit.id === condition.visitId)?.number}</strong>
                </Typography>
            );
        case "minDate":
            return condition.date ? (
                <Typography variant="caption">
                    Min date <strong>{formatDate(new Date(condition.date))}</strong>
                </Typography>
            ) : undefined;
        case "maxDate":
            return condition.date ? (
                <Typography variant="caption">
                    Max date <strong>{formatDate(new Date(condition.date))}</strong>
                </Typography>
            ) : undefined;
    }
}
